<div *ngIf="palette.isOpen()" class="command-palette-backdrop" (mousedown)="close()">
  <div class="command-palette" role="dialog" aria-modal="true" [attr.aria-label]="'commandPalette.title' | translate"
    (mousedown)="$event.stopPropagation()">
    <div class="command-palette-search">
      <i class="pi pi-search" aria-hidden="true"></i>
      <input #searchInput type="text" role="combobox" aria-expanded="true" aria-autocomplete="list"
        aria-controls="command-palette-list" [attr.aria-activedescendant]="activeOptionId()"
        [placeholder]="'commandPalette.placeholder' | translate" [value]="query()" (input)="onQuery($event)"
        (keydown)="onKeydown($event)" autocomplete="off" spellcheck="false" />
      <!-- i18n-ignore: keyboard key name -->
      <kbd>Esc</kbd>
    </div>

    <!-- Rows are not focusable: focus stays in the search field, the selection follows aria-activedescendant. -->
    <div id="command-palette-list" class="command-palette-list" role="listbox"
      [attr.aria-label]="'commandPalette.title' | translate" (mousedown)="$event.preventDefault()">
      <div *ngFor="let section of sections(); trackBy: trackSection" role="group"
        [attr.aria-labelledby]="'command-palette-group-' + section.group">
        <div class="command-palette-group" [id]="'command-palette-group-' + section.group">
          {{ 'commandPalette.groups.' + section.group | translate }}
        </div>
        <div *ngFor="let row of section.rows; trackBy: trackRow" class="command-palette-item" role="option"
          [id]="optionId(row.index)" [class.command-palette-item-active]="row.index === activeIndex()"
          [attr.aria-selected]="row.index === activeIndex()" (mousemove)="onPointerMove(row.index)" (click)="run(row.item)">
          <span class="command-palette-item-icon" aria-hidden="true"><i [ngClass]="row.item.command.icon || 'pi pi-angle-right'"></i></span>
          <span class="command-palette-item-text">
            <span class="command-palette-item-title">{{ row.item.title }}</span>
            <span *ngIf="row.item.hint" class="command-palette-item-hint">{{ row.item.hint }}</span>
          </span>
          <span *ngIf="row.item.command.current" class="command-palette-item-current">{{ 'commandPalette.current' | translate }}</span>
          <kbd *ngIf="row.item.command.shortcut" class="command-palette-item-shortcut">{{ row.item.command.shortcut }}</kbd>
          <i *ngIf="row.index === activeIndex()" class="pi pi-arrow-right command-palette-item-enter" aria-hidden="true"></i>
        </div>
      </div>

      <div *ngIf="!rows().length" class="command-palette-empty">
        <i class="pi pi-search" aria-hidden="true"></i>
        <span>{{ 'commandPalette.empty' | translate }}</span>
      </div>
    </div>

    <div class="command-palette-footer" aria-hidden="true">
      <span><kbd>↑</kbd><kbd>↓</kbd> {{ 'commandPalette.hints.navigate' | translate }}</span>
      <span><kbd>↵</kbd> {{ 'commandPalette.hints.select' | translate }}</span>
      <!-- i18n-ignore: keyboard key name -->
      <span><kbd>Esc</kbd> {{ 'commandPalette.hints.close' | translate }}</span>
    </div>
  </div>
</div>
